module.exports = __webpack_public_path__ + "img/home.4223e02c.png";